
const taxStore = () =>{
    const acceptInfo = ref({})
    const personCollectionList = ref([])
    const transferAdditionalList = ref([])
    const userAnswer = ref([])


    const setPersonCollectionList = (val) =>{
        personCollectionList.value = [...val]
    }
    const setTransferAdditionalList = (val) =>{
        transferAdditionalList.value = [...val]
    }
    const setUserAnswer = (val) =>{
        userAnswer.value = [...val]
    }
    const answer = computed(() =>{
        if(acceptInfo.value.answer){
            return JSON.parse(acceptInfo.value.answer)
        }
        return []
    })
    const saveSolution = computed({
        get(){
            return {
                personCollectionList:toRaw(personCollectionList.value),
                transferAdditionalList:toRaw(transferAdditionalList.value),
                userAnswer:toRaw(userAnswer.value)
            }
        },
        set(value){
            if(value){
                personCollectionList.value = value.personCollectionList
                transferAdditionalList.value = value.transferAdditionalList
                userAnswer.value = value.userAnswer
            } else { // 实现切题，清空数据
                personCollectionList.value = []
                transferAdditionalList.value = []
                userAnswer.value = []
            }
        }
    })
    const setAcceptInfo = (val) =>{
        acceptInfo.value = { ...val }
    }
    const reset = () =>{
        acceptInfo.value = {}
        personCollectionList.value = []
        transferAdditionalList.value = []
        userAnswer.value = []
    }
    return {
        personCollectionList,
        transferAdditionalList,
        userAnswer,
        acceptInfo,
        answer,
        saveSolution,
        setPersonCollectionList,
        setTransferAdditionalList,
        setUserAnswer,
        setAcceptInfo,
        reset
    }
}
export const useTaxStore = defineStore('taxStore', taxStore, { persist:{
    enabled:true,
    storage:sessionStorage
}})
